export default __webpack_public_path__ + "static/media/Office Moving.a742d1c9.jpg";